module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/download.worker.360309f7e2433ed17842.js");
}
